module.exports = __webpack_public_path__ + "img/gy.9669e2ae.svg";